// removed by extract-text-webpack-plugin
module.exports = {"Checkout":"Checkout__Checkout__1EwtK","Button":"Checkout__Button__32JCP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Developer/Checkout/Checkout.css
// module id = 181
// module chunks = 0